import { RECEIPT_LAYOUT_LABELS } from '../../utils/networkMode.js';
import Button from './Button.js';

const LAYOUTS = ['large', 'short', 'legal', 'laser3', 'thermal'];

/**
 * Choose a receipt layout (or All) before printing from list / view.
 */
export default function ReceiptPrintChooser({
  open,
  shipmentId,
  onClose,
  onSelect,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-sm rounded-xl bg-white shadow-xl p-4">
        <p className="text-sm font-semibold text-gray-900">Print receipt</p>
        <p className="text-xs text-gray-500 mt-1 mb-3">
          {shipmentId ? `GC ${shipmentId}` : 'Choose a layout'}
        </p>
        <div className="space-y-2">
          {LAYOUTS.map((id) => (
            <button
              key={id}
              type="button"
              onClick={() => onSelect(id)}
              className="w-full text-left px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 text-sm font-medium text-gray-800"
            >
              {RECEIPT_LAYOUT_LABELS[id] || id}
            </button>
          ))}
          <button
            type="button"
            onClick={() => onSelect('all')}
            className="w-full text-left px-3 py-2 rounded-lg border border-blue-200 bg-blue-50 hover:bg-blue-100 text-sm font-semibold text-blue-800"
          >
            All layouts
          </button>
        </div>
        <div className="flex justify-end mt-4">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </div>
  );
}
